import { EntityId } from './base';
import { IApprovalRequestCategory } from './approval-request-category.model';
import { IUser } from './approval-request-user.model';
import { ApprovalRequestStatus } from './enumerations';
import { IDocument } from './document.model';

export interface IApprovalRequest {
  id?: EntityId;
  categoryId?: string;
  requestType?: string;
  code?: string;
  status?: ApprovalRequestStatus;
  reason?: string;
  documentIds?: Array<string>;
  description?: string;
  deadlineDate?: number;
  eventDate?: number;
  startDate?: number;
  endDate?: number;
  createdDate?: number;
  updatedDate?: number;
  approvedDate?: number;
  canceledDate?: number;
  rejectedDate?: number;
  category?: IApprovalRequestCategory;
  requester?: IUser;
  approver?: IUser;
  totalLeaveDays?: number;
  documents?: IDocument[];
}

export class ApprovalRequest implements IApprovalRequest {
  id?: EntityId = null;
  categoryId?: string = null;
  requestType?: string = null;
  code?: string = null;
  status?: ApprovalRequestStatus = null;
  reason?: string = "";
  documentIds?: Array<string> = [];
  description?: string = null;
  deadlineDate?: number = null;
  eventDate?: number = null;
  startDate?: number = null;
  endDate?: number = null;
  createdDate?: number = null;
  updatedDate?: number = null;
  approvedDate?: number = null;
  canceledDate?: number = null;
  rejectedDate?: number = null;
  category?: IApprovalRequestCategory = null;
  requester?: IUser = null;
  approver?: IUser = null;
  totalLeaveDays?: number = null;
}
